module.exports = __webpack_public_path__ + "static/media/arrow-up.48e2f99d.svg";